import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deletePayment } from "api/payment.api";
import {
  invalidateDashboardSources,
  invalidatePaymentSide,
} from "lib/cacheInvalidation";

export const useDeletePayment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deletePayment,
    onSuccess: () => {
      invalidatePaymentSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
